import { useState } from 'react';
import axios from '../utils/axiosWithAuth'; // or './utils/axiosWithAuth' based on your file

import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase/firebase'; // update path if needed

export default function SubscribeForm() {
  const [user] = useAuthState(auth);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
  e.preventDefault();
  setMessage('');

  if (!user?.email) {
    setMessage('❌ Please log in to subscribe.');
    return;
  }

  setLoading(true);
  try {
    const idToken = await auth.currentUser.getIdToken(true);

   const res = await axios.post(
  `${process.env.REACT_APP_API_URL}/api/save-subscriber`,
      {}, // 👈 empty body — email is extracted from token
      {
        headers: {
          Authorization: `Bearer ${idToken}`, // 👈 pass token securely
        },
      }
    );

    setMessage(res.data.message);
  } catch (error) {
    console.error("❌ Subscription error:", error?.response?.data || error.message);
    setMessage('❌ Subscription failed. Please try again later.');
  } finally {
    setLoading(false);
  }
};


  return (
    <div
      style={{
        padding: '30px',
        maxWidth: '400px',
        margin: 'auto',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
      }}
    >
      <h2 style={{ color: '#0056D2' }}>Subscribe for Daily Job Alerts</h2>

      <form onSubmit={handleSubmit}>
        <label style={{ display: 'block', marginBottom: '8px', textAlign: 'left' }}>
          Your Email:
        </label>
        <input
          type="email"
          required
          value={user?.email || ''}
          readOnly
          style={{
            padding: '12px',
            width: '100%',
            marginBottom: '12px',
            fontSize: '16px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: '#f1f1f1',
            cursor: 'not-allowed',
          }}
        />

        <button
          type="submit"
          disabled={!user || loading}
          style={{
            padding: '12px 20px',
            backgroundColor: '#0056D2',
            color: 'white',
            border: 'none',
            cursor: !user || loading ? 'not-allowed' : 'pointer',
            width: '100%',
            borderRadius: '4px',
            fontSize: '16px',
          }}
        >
          {loading ? 'Subscribing...' : 'Subscribe'}
        </button>
      </form>

      {message && (
        <p
          style={{
            marginTop: '15px',
            color: message.includes('success') || message.includes('subscribed') ? 'green' : '#cc0000',
            fontSize: '14px',
          }}
        >
          {message}
        </p>
      )}
    </div>
  );
}
